module.exports = __webpack_public_path__ + "media/assets/article-icon-2-d638f2ce1f490ecee74f504a844b0a6adf1e207c4088bde047d1b89fcc5df38f.png";